// components/AdminOtpSender.js
import React, { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../services/firebase";
import Layout from "../component/Layout";

const AdminOtpSender = () => {
  const [otps, setOtps] = useState([]);
  const [loading, setLoading] = useState({});

  // Load pending OTPs
  const loadOtps = async () => {
    try {
      const q = query(collection(db, "otps"), where("status", "==", "pending"));
      const snap = await getDocs(q);
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setOtps(list);
    } catch (err) {
      console.error("Failed to load OTPs:", err);
      alert("Could not load pending OTPs.");
    }
  };

  useEffect(() => {
    loadOtps();
    // Optionally refresh every 30 seconds
    const interval = setInterval(loadOtps, 30000);
    return () => clearInterval(interval);
  }, []);

  // Open WhatsApp with pre-filled message
  const sendOtp = async (otpEntry) => {
    const { mobile, message, id } = otpEntry;

    // Create clean WhatsApp URL
    const whatsappUrl = `https://wa.me/${mobile.replace(
      /[^0-9]/g,
      ""
    )}?text=${encodeURIComponent(message)}`;

    // Mark as "sent" in Firestore
    setLoading((prev) => ({ ...prev, [id]: true }));

    try {
      // Update status first
      await updateDoc(doc(db, "otps", id), {
        status: "sent",
        sentByAdmin: true,
        sentAt: new Date(),
      });

      // Open WhatsApp in new tab
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");

      // Remove from local list
      setOtps((prev) => prev.filter((o) => o.id !== id));
    } catch (err) {
      console.error("Failed to mark OTP as sent:", err);
      alert("Could not update status. Please check connection.");
    } finally {
      setLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  return (
    <Layout title="Send OTP">
    <div className="admin-otp-panel">
      <h3>📤 Pending OTPs to Send</h3>
      {otps.length === 0 ? (
        <p>All caught up! 🎉</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {otps.map((entry) => (
            <li
              key={entry.id}
              style={{
                border: "1px solid #ddd",
                margin: "8px 0",
                padding: "12px",
                borderRadius: "6px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <strong>{entry.mobile}</strong> • {entry.useCase}
              <br />
              <small style={{ color: "#555", fontStyle: "italic" }}>
                {entry.message}
              </small>
              <br />
              <button
                onClick={() => sendOtp(entry)}
                disabled={loading[entry.id]}
                style={{
                  marginTop: "8px",
                  padding: "6px 12px",
                  backgroundColor: loading[entry.id] ? "#ccc" : "#25D366",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                {loading[entry.id] ? "Opening..." : "Send via WhatsApp"}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
    </Layout>
  );
};

export default AdminOtpSender;